module.exports = __webpack_public_path__ + "static/img/btn4.1c5db11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloads/btn4.png
// module id = fvKC
// module chunks = 0